import type {PerkIntegrationConfigComponentProps} from '@cohort/merchants/apps';
import ConnectionPicker from '@cohort/merchants/components/connections/ConnectionPicker';
import UrlInput from '@cohort/merchants/components/form/v2/UrlInput';
import HighlightText from '@cohort/merchants/components/HighlightText';
import {Trans, useTranslation} from 'react-i18next';

const PRESTASHOP_DOCUMENTATION_LINK =
  'https://cohort-xyz.notion.site/Setup-Prestashop-Perk-60f5841616964089a6839086e6767a3f';

const PrestashopGroupPerkIntegrationConfigComponent: React.FC<
  PerkIntegrationConfigComponentProps
> = ({formReturn: {register, control}}) => {
  const {t} = useTranslation('app-prestashop', {
    keyPrefix: 'perkIntegrations.group.configComponent',
  });

  return (
    <div className="space-y-6">
      <HighlightText
        type="info"
        text={
          <label>
            <Trans
              i18nKey="perkIntegrations.group.configComponent.description"
              ns="app-prestashop"
              components={{
                notionLink: (
                  <a
                    className="cursor-pointer font-semibold text-primary"
                    href={PRESTASHOP_DOCUMENTATION_LINK}
                    target="_blank"
                    rel="noreferrer"
                  />
                ),
              }}
            />
          </label>
        }
      />
      <ConnectionPicker appId="prestashop" register={register} control={control} />
      <UrlInput
        type="text"
        name="integration.config.loginUrl"
        label={t('labelLoginUrl')}
        description={t('descriptionLoginUrl')}
        register={register}
        control={control}
      />
      <UrlInput
        type="text"
        name="integration.config.registrationUrl"
        label={t('labelRegistrationUrl')}
        description={t('descriptionRegistrationUrl')}
        register={register}
        control={control}
      />
    </div>
  );
};

export default PrestashopGroupPerkIntegrationConfigComponent;
